export default {

    byId: state => id => {
        return state.entities[id]
    }

}


